<template>
  <page pageName="policy">
    <v-row>
      <v-col class="px-6">
        <v-row class="px-0 pt-12">
          <v-col>
            <h1 class="center--text gm-darkblue--text">Policy</h1>
          </v-col>
        </v-row>

        <p>
          The long-term business success of Greenmasters Limited depends on our ability to continually improve the quality of our services and products while protecting people and the environment.
        </p>
        <p>
          Emphasis must be placed on ensuring human health, operational safety, environmental protection, quality enhancement, and community safety. This commitment is in the best interests of our customers, our employees and contractors, our stockholders, and the communities in which we live and work.
        </p>
        <p>
          Greenmasters Limited requires the active commitment to and accountability for QHSE from all employees and contractors. Line management has a leadership role in the communication and implementation of and ensuring compliance with QHSE policies and standards.
        </p>
        <p>
          We are committed to protect and strive for improvement of the health, safety, and security of our people at all times;
        </p>
        <p>
          <ul>
            <li>
              eliminate quality non conformances and HSE accidents meet specified customer requirements and ensure continuous customer satisfaction
            </li>
            <li>
              set quality and HSE performance objectives
            </li>
            <li>
              measure and assess results and continually improve processes, services, and product quality through the use of an effective management system
            </li>
            <li>
              plan for, respond to, and recover from any emergency, crisis, and business disruption
            </li>
            <li>
              minimize our impact on the environment through pollution prevention, reduction of natural resource consumption and emissions, and the reduction and recycling of waste
            </li>
            <li>
              apply our technical skills to all HSE aspects in the design and engineering of our services and products
            </li>
            <li>
              communicate openly with stakeholders and ensure an understanding of our QHSE policies, standards, programs and performance
            </li>
            <li>
              reward outstanding QHSE performance
            </li>
            <li>
              improve our performance on issues relevant to our stakeholders that are of global concern and on which we can have an impact and share with them our knowledge of successful QHSE programs and initiatives.
            </li>
          </ul>
        </p>
        <p>
          This Policy shall be regularly reviewed to ensure ongoing suitability.
          The commitments listed are in addition to our basic obligation to comply with Greenmasters Limited standards as well as all applicable laws and regulations where we operate.
        </p>
        <p>
          This is critical to our business success because it allows us to systematically minimize all losses and adds value for all our stakeholders.
        </p>
      </v-col>
    </v-row>
  </page>
</template>

<script>
export default {
  name: 'policy'
}
</script>

<style scoped>

</style>
